import { createFileRoute, redirect } from "@tanstack/react-router";
import { getStoredUserRole } from "@/shared/infrastructure/auth/token-storage";
import { AdminDashboardPage } from "@/modules/admin/presentation/pages/AdminDashboardPage";
import { UserRole } from "@/modules/auth/domain/entities";

export const Route = createFileRoute("/_authenticated/admin-users")({
  beforeLoad: () => {
    if (getStoredUserRole() !== UserRole.Admin) {
      throw redirect({ to: "/" });
    }
  },
  component: AdminDashboardPage,
});
